import React from "react";
import { connect } from "react-redux";
import HMenu from "./HMenu/HMenu";
import AnimateLoading from "../../../app/partials/layout/AnimateLoading";
import PSBHeader from "../../_assets/js/header";
import clsx from "clsx";

class Header extends React.Component {
	headerCommonRef = React.createRef();
	style = clsx({ ar: this.props.lang === "ar" });

	componentDidMount() {
		let options = {};
		if (
			this.headerCommonRef.current.getAttribute("data-ktheader-minimize") ===
			"1"
		) {
			options["minimize.desktop.on"] = "kt-header--minimize";
			options["offset.desktop"] = 130;
		}

		// eslint-disable-next-line no-undef
		new PSBHeader(this.headerCommonRef.current, options);
	}

	render() {
		const menuHeaderDisplay = true;
		return (
			<div
				className={`kt-header kt-grid__item kt-header--fixed ${this.props.lang}`}
				id="kt_header"
				ref={this.headerCommonRef}
			>
				<AnimateLoading />
				{/* <!-- begin: Header Menu --> */}
				{menuHeaderDisplay && <HMenu />}
				{/* <!-- end: Header Menu --> */}
				{/* <!-- begin:: Header Topbar --> */}
				{/* <!-- empty div to fix topbar to stay on the right when menu-horizontal is hidden --> */}
				{!menuHeaderDisplay && <div />}
				{/* <!-- end:: Header Topbar --> */}
			</div>
		);
	}
}

const mapStateToProps = (store) => ({
	lang: store.i18n.lang,
});

export default connect(mapStateToProps)(Header);
